import { AppAction } from '../app';

export const FETCH_CUSTOMER_REQUIREMENT = 'FETCH_CUSTOMER_REQUIREMENT';
export const CLEAR_CUSTOMER_REQUIREMENT = 'CLEAR_CUSTOMER_REQUIREMENT';

export const fetchCustomerRequirement = (crtNumber: string): AppAction => ({
  type: FETCH_CUSTOMER_REQUIREMENT,
  payload: crtNumber,
});

export const clearCustomerRequirement = () => ({
  type: CLEAR_CUSTOMER_REQUIREMENT,
});
